import trim from 'lodash/trim'

export const mapCategories = {
  INTRO: {
    category: 'INTRO',
    title: 'Coach Intros',
    suggestedName: 'Coach Intro',
    description: 'Meet with a PGA Coach to see the facilities, assess your skill level and define your goals. Walk away with a program tailored to you.',
    featuredImageUrl: '/images/Intros.jpg',

  },
  PRIVATE: {
    category: 'PRIVATE',
    title: 'Private Instruction',
    suggestedName: 'Private',
    description: 'Get 1:1 instruction with a PGA Coach to help in any facet of your game.',
    featuredImageUrl: '/images/Private.png',
  },
  ON_COURSE: {
    category: 'ON_COURSE',
    title: 'On Course',
    suggestedName: 'On Course',
    description: 'Play some holes with a PGA Coach. Get help with on course strategy, club selection and real-time optomizations.',
    featuredImageUrl: '/images/On Course.jpg',
  },
  SWING_EVALUATION: {
    category: 'SWING_EVALUATION',
    title: 'Swing Evaluation',
    suggestedName: 'Swing Eval',
    description: 'Can’t shake a slice or a hook? Want to fine-tune your swing? An evaluation will help you make the right adjustments based on your goals.',
    featuredImageUrl: '/images/Swing Evaluation.png',
    featuredImageUrlMobile: '/images/Swing Evaluation(mobile).png',
  },
  CLUB_FITTING: {
    category: 'CLUB_FITTING',
    title: 'Club Fitting',
    suggestedName: 'Club Fitting',
    description: 'Make your clubs work for you. Improve your game by getting fitted with a specialist.',
    featuredImageUrl: '/images/Fitting Club.jpg',
  },
  OTHER: {
    category: 'OTHER',
    title: 'Other',
    suggestedName: 'Other',
    description: 'This is a custom booking type.',
    featuredImageUrl: '/images/On Course.jpg',
  },
  SECOND_SWING: {
    category: '2ND_SWING',
    title: '2nd Swing Club Fitting',
    suggestedName: '2nd Swing Club Fitting',
    description: 'Precision meets performance at the PGA Coaching Center with tailored club fittings from 2nd Swing.',
    featuredImageUrl: '/images/fitting-club.png',
    featuredImageUrlMobile: '/images/fitting-club(mobile).png',
    logo: '/images/logo-2ndswing-V4.png',
    externalUrl: 'https://www.2ndswing.com/golf-club-fittings/schedule-now?location=417',
  },
}

export const defineMinimumPricePerLesson = (lessonPacks) => {
  if (lessonPacks.length === 0) return null
  return Math.min(...lessonPacks.map(item => item.priceInCents / item.quantity))
}

export const formattedAddress = (facility) => {
  const {
    address1, city, state, zip,
  } = facility
  let result = ''
  if (address1) result += `${address1}, `
  if (city) result += `${city}, `
  if (state) result += `${state} `
  if (zip) result += zip.slice(0, 5)
  return trim(result, ', ') // trims whitespace and trailing commas
}

export const featuredStory = {
  title: 'A Path Forward at PGA HOPE National Golf & Wellness Week',
  headline: 'A Path Forward at PGA HOPE National Golf & Wellness Week',
  slug: 'a-path-forward-at-pga-hope-national-golf-and-wellness-week',
  cat: {
    category: 'Editorial',
    series: 'Events',
    __typename: 'Category',
  },
  author: null,
  body: {
    json: '{content: Array(12), data: {…}, nodeType: \'document…}',
    links: '{__typename: \'StoryBodyLinks\', entries: {…}}',
    __typename: 'StoryBody',
  },
  sys: {
    publishedAt: '2022-10-12T16:05:46.173Z',
    firstPublishedAt: '2022-10-11T20:39:25.578Z',
    __typename: 'Sys',
  },
  image: {
    contentType: 'image/jpeg',
    url: 'https://images.ctfassets.net/56u5qdsjym8c/4D1jcGoR1jVGPReIjJkqQx/d0bc64a548b93899b1af25b1dba26372/hopehero.jpg',
    description: 'A PGA HOPE Veteran hits his shot at the North California HOPE Golf Outing during the 102nd PGA Championship at the Olympic Club on August 3, 2020 in San Francisco, California. (Photo by Darren Carroll/PGA of America)',
    height: 900,
    title: 'Hero Image - HOPE Preview',
    width: 1600,
    __typename: 'Asset',
  },
  heroVideoEmbed: null,
  heroSource: null,
  heroCaption: null,
  tagsCollection: {
    items: '[]',
    __typename: 'StoryTagsCollection',
  },
  person: null,
  summary: 'PGA HOPE is a six to eight week program for Veterans to learn the game taught by PGA Professionals trained in adaptive golf and military cultural competency. ',
  recommended: {
    headline: null,
    articlesCollection: '{__typename: \'RecommendedArticlesArticlesCollection…}',
    __typename: 'RecommendedArticles',
  },
  related: null,
  __typename: 'Story',
  published: '2022-10-11T20:39:25.578Z',
  video: 'https://www.youtube.com/embed/NAo2RDMObWE?enablejsapi=1&origin=https%3A%2F%2Fwww.pga.com',
  url: 'https://www.pga.com/story/a-path-forward-at-pga-hope-national-golf-and-wellness-week',
}

export const featuredStories = [
  {
    title: 'A Path Forward at PGA HOPE National Golf & Wellness Week',
    headline: 'A Path Forward at PGA HOPE National Golf & Wellness Week',
    slug: 'a-path-forward-at-pga-hope-national-golf-and-wellness-week',
    cat: {
      category: 'Editorial',
      series: 'Events',
      __typename: 'Category',
    },
    author: null,
    body: {
      json: '{content: Array(12), data: {…}, nodeType: \'document…}',
      links: '{__typename: \'StoryBodyLinks\', entries: {…}}',
      __typename: 'StoryBody',
    },
    sys: {
      publishedAt: '2022-10-12T16:05:46.173Z',
      firstPublishedAt: '2022-10-11T20:39:25.578Z',
      __typename: 'Sys',
    },
    image: {
      contentType: 'image/jpeg',
      url: 'https://images.ctfassets.net/56u5qdsjym8c/4D1jcGoR1jVGPReIjJkqQx/d0bc64a548b93899b1af25b1dba26372/hopehero.jpg',
      description: 'A PGA HOPE Veteran hits his shot at the North California HOPE Golf Outing during the 102nd PGA Championship at the Olympic Club on August 3, 2020 in San Francisco, California. (Photo by Darren Carroll/PGA of America)',
      height: 900,
      title: 'Hero Image - HOPE Preview',
      width: 1600,
      __typename: 'Asset',
    },
    video: null,
    heroVideoEmbed: null,
    heroSource: null,
    heroCaption: null,
    tagsCollection: {
      items: '[]',
      __typename: 'StoryTagsCollection',
    },
    person: null,
    summary: 'PGA HOPE is a six to eight week program for Veterans to learn the game taught by PGA Professionals trained in adaptive golf and military cultural competency. ',
    recommended: {
      headline: null,
      articlesCollection: '{__typename: \'RecommendedArticlesArticlesCollection…}',
      __typename: 'RecommendedArticles',
    },
    related: null,
    __typename: 'Story',
    published: '2022-10-11T20:39:25.578Z',
  },
  {
    title: 'PGA HOPE National Golf & Wellness Week: A Life-Changing Experience',
    headline: 'PGA HOPE National Golf & Wellness Week: A Life-Changing Experience',
    slug: 'pga-hope-national-golf-and-wellness-week-a-life-changing-experience',
    cat: {
      category: 'Editorial',
      series: 'Events',
      __typename: 'Category',
    },
    author: null,
    body: {
      json: '{content: Array(9), data: {…}, nodeType: \'document\'}',
      links: '{__typename: \'StoryBodyLinks\', entries: {…}}',
      __typename: 'StoryBody',
    },
    sys: {
      publishedAt: '2022-10-14T21:59:37.075Z',
      firstPublishedAt: '2022-10-14T21:50:58.174Z',
      __typename: 'Sys',
    },
    image: {
      contentType: 'image/jpeg',
      url: 'https://images.ctfassets.net/56u5qdsjym8c/4zxm6qjOr5xD0ZXpkaQs7t/c31337baa05275d65c7f897158244ae9/pgahope1hero.jpg',
      description: 'Will Stockholm during the Golf Training event for PGA HOPE National Golf & Wellness Week in Washington, DC, on October 26, 2019. (Photo by Michael Cohen/ Getty Images)',
      height: 900,
      title: 'Hero Image - Will Stockholm',
      width: 1600,
      __typename: 'Asset',
    },
    video: null,
    heroVideoEmbed: null,
    heroSource: null,
    heroCaption: null,
    tagsCollection: {
      items: '[]',
      __typename: 'StoryTagsCollection',
    },
    person: null,
    summary: 'As we head into PGA HOPE National Golf & Wellness week, we recognize how much of an impact golf can make on the Veterans it serves. ',
    recommended: {
      headline: null,
      articlesCollection: '{__typename: \'RecommendedArticlesArticlesCollection…}',
      __typename: 'RecommendedArticles',
    },
    related: null,
    __typename: 'Story',
    published: '2022-10-14T21:50:58.174Z',
  },
  {
    title: 'Runway of PGA HOPE',
    headline: 'Runway of PGA HOPE',
    slug: 'runway-of-pga-hope',
    cat: {
      category: 'Editorial',
      series: 'Game Changers',
      __typename: 'Category',
    },
    author: 'Keith Stewart, PGA',
    body: {
      json: '{content: Array(20), data: {…}, nodeType: \'document…}',
      links: '{__typename: \'StoryBodyLinks\', entries: {…}}',
      __typename: 'StoryBody',
    },
    sys: {
      publishedAt: '2022-10-05T01:08:03.601Z',
      firstPublishedAt: '2022-10-04T13:51:10.413Z',
      __typename: 'Sys',
    },
    image: {
      contentType: 'image/png',
      url: 'https://images.ctfassets.net/56u5qdsjym8c/6syB0DE9SQiLXg3BAOSp6c/b7d2c1e907822fedb1124d026cc0e726/2hope1.png',
      description: 'A participant hits his drive down the runway. ',
      height: 1000,
      title: 'Image - Runway of HOPE',
      width: 1600,
      __typename: 'Asset',
    },
    video: null,
    heroVideoEmbed: null,
    heroSource: null,
    heroCaption: null,
    tagsCollection: {
      items: '[]',
      __typename: 'StoryTagsCollection',
    },
    person: null,
    summary: 'Rich Scott took a vision and made it into a reality. Runway of Hope took place on Saturday, September 17th at the Fulton County Airport. Rich organized a charity Long Drive Contest to benefit the winter PGA HOPE programs he coordinates at Fox Run. ',
    recommended: {
      headline: null,
      articlesCollection: '{__typename: \'RecommendedArticlesArticlesCollection…}',
      __typename: 'RecommendedArticles',
    },
    related: null,
    __typename: 'Story',
    published: '2022-10-04T13:51:10.413Z',
  }]

export const newsletterSignup = {
  headline: 'Stay Connected to PGA',
  emailHeadline: 'Sign Up',
  emailDescription: 'Sign up for our newsletter to stay up to date on PGA and our programming.',
  showSubscribe: true,
  socialHeadline: 'Social Media',
  socialDescription: 'Follow Us on Social Media',
  socialCollection: {
    items: [
      {
        title: 'Social X',
        link: 'https://twitter.com/pga',
        headline: 'X',
        __typename: 'Token',
      },
      {
        title: 'Social Facebook',
        link: 'https://www.facebook.com/PGAofAmerica',
        headline: 'Facebook',
        __typename: 'Token',
      },
      {
        title: 'Social Instagram',
        link: 'https://www.instagram.com/Pga/',
        headline: 'Instagram',
        __typename: 'Token',
      },
      {
        title: 'Social Youtube',
        link: 'https://www.youtube.com/channel/UCnUYyAtDiyeaobSzKqVE_BA',
        headline: 'YouTube',
        __typename: 'Token',
      },
      {
        title: 'Social LinkedIn',
        link: 'https://www.linkedin.com/company/pga-of-america/',
        headline: 'Linkedin',
        __typename: 'Token',
      },
      {
        title: 'Social TikTok',
        link: 'https://www.tiktok.com/@pgaofamerica',
        headline: 'TikTok',
        __typename: 'Token',
      },
    ],
    __typename: 'NewsletterSignupSocialCollection',
  },
  __typename: 'NewsletterSignup',
}

export const coachingCenterNewsletterSignup = {
  headline: 'Stay Connected to the PGA Coaching Center',
  showSubscribe: true,
  emailHeadline: 'Sign Up',
  emailDescription: 'Sign up for our newsletter to stay up to date on PGA and our programming.',
}

export const composeBookingUrl = ({
  coach, lessonTypeId, facilities, isLessonPack,
}) => {
  const facilityId = facilities && facilities?.length > 0 && facilities[0]?.id
  if (!lessonTypeId || !facilityId || !coach?.bookingUrl) return null

  if (isLessonPack) {
    return `${coach.bookingUrl}?lessonTypeId=${lessonTypeId}&locationId=${facilityId}&isLessonPacks=true&returnTo=${typeof window !== 'undefined' && window.location.href}`
  }
  return `${coach.bookingUrl}?lessonTypeId=${lessonTypeId}&locationId=${facilityId}&returnTo=${typeof window !== 'undefined' && window.location.href}`
}
